module.exports = __webpack_public_path__ + "02_veryshort_grey.223d425e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_veryshort_grey.png
// module id = mX6i
// module chunks = 0